import React from 'react';
import { VORONOI_CONTEXT } from '@/constants/context';
import { VIDEO_URLS } from '@/constants/videos';

const Voronoi = () => {
  return (
    <div
      id='content-Voronoi'
      className='w-full h-full flex flex-col justify-center items-center md:gap-16 xl:pb-32 gap-4 xl:gap-14'
    >
      <section className='w-full flex justify-center items-center px-14 md:-mx-24 xl:mx-0 md:px-20'>
        <video
          className='w-full xl:w-[640px] xl:h-[360px] pointer-events-none select-none'
          muted
          autoPlay
          loop
          controls={false}
          disablePictureInPicture
          playsInline
          onContextMenu={e => e.preventDefault()}
        >
          <source src={VIDEO_URLS.CA_SIMULATION} />
        </video>
      </section>
      <section className='w-full flex flex-col gap-4 md:gap-6 xl:gap-6'>
        {/* Mobile: Stacked layout */}
        <div className='flex flex-col xl:hidden gap-2 md:gap-6'>
          <strong className='text-[20px] font-bold text-white md:text-[32px]'>
            {VORONOI_CONTEXT.TITLE}
          </strong>
          <div className='w-full flex flex-row md:gap-4 gap-2'>
            <div className='w-1 bg-[#FCCB16]'></div>
            <div className='text-[14px] font-semibold text-white md:text-[20px]'>
              <p>{VORONOI_CONTEXT.SUBTITLE}</p>
            </div>
          </div>
        </div>

        {/* Desktop: Horizontal layout */}
        <div className='hidden xl:flex items-center gap-4'>
          <strong className='text-4xl font-bold text-white whitespace-nowrap'>
            {VORONOI_CONTEXT.TITLE}
          </strong>
          <div className='w-1 h-8 bg-[#FCCB16]'></div>
          <div className='text-xl font-semibold text-white'>
            {VORONOI_CONTEXT.SUBTITLE}
          </div>
        </div>

        <div className='w-full flex flex-col gap-1 md:gap-3 xl:gap-3'>
          <article className='text-[14px] md:text-lg font-medium text-white xl:truncate'>
            {VORONOI_CONTEXT.DESCRIPTION1}
          </article>
          {VORONOI_CONTEXT.DESCRIPTION2.map((item, index) => {
            return (
              <article
                key={index}
                className='text-[14px] md:text-lg font-medium text-white md:text-justify'
              >
                {item}
              </article>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default React.memo(Voronoi);
